import type { TaskDefinition } from './types'

/**
 * Onboarding task definitions
 */
export const TASKS: TaskDefinition[] = [
  {
    id: 'complete-profile',
    title: 'Complete your profile',
    description: 'Add your name and upload an avatar so teammates recognise you.',
    action: { label: 'Open settings', href: '/settings' },
    notification: {
      title: 'Profile updated',
      message: 'Looking good! Personalising your profile unlocks better collaboration.',
      type: 'success',
    },
    tip: 'Finished profiles build trust with collaborators—add a photo & display name.',
  },
  {
    id: 'enable-weekly-recap',
    title: 'Enable weekly recaps',
    description: 'Get recurring product updates and visibility into your recent activity.',
    autoCompleteEvent: 'enable-weekly-recap',
    notification: {
      title: 'Weekly recap enabled',
      message: 'You will receive a Monday morning summary of key updates.',
      type: 'success',
    },
    tip: 'Weekly recaps help you stay aligned with product activity.',
  },
  {
    id: 'install-app',
    title: 'Install the app',
    description: 'Add Zippity to your home screen or dock for one-click access.',
    autoCompleteEvent: 'install-app',
    notification: {
      title: 'Installed on your device',
      message: 'Launch Zippity directly from your desktop or mobile home screen.',
      type: 'info',
    },
    tip: 'Installed apps reduce friction—launch from your dock instead of typing the URL.',
  },
  {
    id: 'share-feedback',
    title: 'Share your first piece of feedback',
    description: 'Open the help center and tell us what would make the product better.',
    autoCompleteEvent: 'share-feedback',
    notification: {
      title: 'Thanks for the feedback!',
      message: 'We read every idea—your request is on our product radar.',
      type: 'success',
    },
    tip: 'Submitting feedback gives you priority when new features roll out.',
  },
  {
    id: 'configure-billing',
    title: 'Review booking page appearance',
    description: 'Open appearance and verify the customer-facing look and feel.',
    action: { label: 'Open appearance', href: '/appearance' },
    notification: {
      title: 'Appearance reviewed',
      message: 'Your booking page look and feel is ready to keep refining.',
      type: 'info',
    },
    tip: 'Preview stays available even if you postpone public access.',
  },
]
